import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { faSalad } from '@fortawesome/pro-thin-svg-icons';
// import '../styles/componentStyles/NutritionList.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/sharp-regular-svg-icons';
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { nutrition_list } from '../../shared/components/data';
import NumberInput from '../components/NumberInput';

function NutritionList(props) {
  const { t } = useTranslation();
  const [lines, setLines] = useState([
    {
      id: 0,
      selectedItem: '',
      count: 0,
      db_id: null,
    },
  ]);
  const inputRefs = useRef([]);
  const lastAddedLineId = useRef(null);

  useEffect(() => {
    // Focus on newly added nutrition item
    if (lastAddedLineId.current !== null) {
      inputRefs.current[lastAddedLineId.current].focus();
      lastAddedLineId.current = null;
    }
  }, [lines]);

  useEffect(() => {
    // Prevent scrolling on number input
    const handleWheel = (event) => {
      event.preventDefault();
    };

    inputRefs.current.forEach((input) => {
      if (input) {
        input.addEventListener('wheel', handleWheel);
      }
    });

    return () => {
      inputRefs.current.forEach((input) => {
        if (input) {
          input.removeEventListener('wheel', handleWheel);
        }
      });
    };
  }, [lines]);

  useEffect(() => {
    if (props.resetLines) {
      setLines([
        {
          id: 0,
          selectedItem: '',
          count: 0,
          db_id: null,
        },
      ]);
      props.setResetLines(false);
    }
  }, [props.resetLines]);

  useEffect(() => {
    if (props.data?.[props.questionid]?.[0]?.count) {
      const arr = [...props.data[props.questionid]];
      const modifiedArr = arr.map((el, index) => {
        const item = nutrition_list.find((item) => item.id === el.id);
        return {
          id: index,
          selectedItem: t(item.label),
          count: el.count,
          db_id: el.id,
        };
      });
      setLines(modifiedArr);
    }
  }, [props.data?.[props.questionid]?.[0]?.count]);

  useEffect(() => {
    const dbArray = [];
    lines.forEach((line) => {
      if (line.db_id && line.count > 0) {
        dbArray.push({ id: line.db_id, count: line.count });
      }
    });

    props.saveResponse('data', {
      id: props.questionid,
      value: dbArray,
    });
  }, [lines]);

  const handleDeleteLine = (id) => {
    setLines(lines.filter((line) => line.id !== id));
  };

  const handleAddLine = () => {
    const newLineId = lines.length > 0 ? lines[lines.length - 1].id + 1 : 0;
    lastAddedLineId.current = newLineId;

    setLines([
      ...lines,
      {
        id: newLineId,
        selectedItem: '',
        count: 0,
        db_id: null,
      },
    ]);
  };

  const handleItemChange = (event, lineId) => {
    const selectedOption = nutrition_list.find((item) => t(item.label) === event.target.value);

    setLines((prevLines) =>
      prevLines.map((line) => {
        if (line.id === lineId) {
          return {
            ...line,
            selectedItem: event.target.value,
            db_id: selectedOption?.id || null,
          };
        }
        return line;
      })
    );
  };

  const handleCountChange = (value, lineId) => {
    setLines((prevLines) =>
      prevLines.map((line) => {
        if (line.id === lineId) {
          return { ...line, count: value };
        }
        return line;
      })
    );
  };

  return (
    <div role="group" aria-label={t('trackers.nutrition.list')}>
      {lines.map((line) => (
        <fieldset
          key={line.id}
          className="tracker-line tracker-select-container no-padding fs-mask"
        >
          <legend className="sr-only">
            {line.selectedItem || t('trackers.nutrition.select.label')}
          </legend>
          <div className="part-line part-line-select">
            <label htmlFor={`nutrition-${line.id}`} className="visuallyHidden">
              {t('trackers.nutrition.select.label')}
            </label>
            <div className="tracker-select-wrapper">
              <select
                ref={(el) => {
                  inputRefs.current[line.id] = el;
                }}
                id={`nutrition-${line.id}`}
                className="tracker-select"
                value={line.selectedItem}
                onChange={(e) => handleItemChange(e, line.id)}
              >
                <option value="" disabled>
                  {t('T071W')}
                </option>
                {nutrition_list.map((item) => (
                  <option key={item.id} value={t(item.label)}>
                    {t(item.label)}
                  </option>
                ))}
              </select>
              <FontAwesomeIcon icon={faChevronDown} className="select-icon" aria-hidden="true" />
            </div>
          </div>
          <div className="part-line part-line-count tracker-input-wrapper">
            <FontAwesomeIcon icon={faSalad} className="tracker-icon salad" aria-hidden="true" />
            <label htmlFor={`count-${line.id}`} className="visuallyHidden">
              {t('Number of portions')}
            </label>
            <NumberInput
              type="inline"
              inputName={`count-${line.id}`}
              startValue={Number(line.count)}
              minValue={0}
              maxValue={20}
              onSetValue={(value) => handleCountChange(value, line.id)}
              controlsInfo={t('T055')}
              ariaLabel={t('trackers.nutritionList.count.label')}
              suffix={t('T055')}
            />
          </div>
          <div className="part-line tracker-remove-item-container">
            <button
              type="button"
              className="tracker-remove-item"
              onClick={() => handleDeleteLine(line.id)}
              aria-label={t('Remove item')}
            >
              <FontAwesomeIcon icon={faTimes} className="icon times" aria-hidden="true" />
            </button>
          </div>
        </fieldset>
      ))}
      <button
        type="button"
        className="tracker-add-line"
        onClick={handleAddLine}
        aria-label={t('Add another item')}
      >
        <div className="icon-cont">
          <FontAwesomeIcon icon={faPlus} className="icon plus" aria-hidden="true" />
        </div>
        <div>{t('T056')}</div>
      </button>
    </div>
  );
}

export default NutritionList;
